import { REDUCERS_NAME } from '../../constants';
import { createActionName } from '../../utility';

export const reducerName = REDUCERS_NAME.COURRIERS_ARRIVEE;

export const COURRIERS_ARRIVEE = createActionName(reducerName, 'COURRIERS_ARRIVEE');
export const DELETE_COURRIERS_ARRIVEE = createActionName(reducerName, 'DELETE_COURRIERS_ARRIVEE');
export const CREATE_COURRIERS_ARRIVEE = createActionName(reducerName, 'CREATE_COURRIERS_ARRIVEE');
export const UPDATE_COURRIERS_ARRIVEE = createActionName(reducerName, 'UPDATE_COURRIERS_ARRIVEE');
